import { useState, useCallback } from "react";
import { caySamApiService } from "src/api/caysam-api";
import { CaySam } from "src/types/caysam";

export function useCaySamNFT() {
    
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [caySam, setCaySam] = useState<CaySam | null>(null);

    const getCaySam = useCallback(async (id: string) => {
        if (!id) {
            setError("Không tìm thấy cây sâm");
            return;
        }

        try {
            setLoading(true);
            setError(null);

            const response = await caySamApiService.getCaySamByNFC(id);

            if (response?.messCode === 1 && response.oneItem) {
                setCaySam(response.oneItem);
            } else {
                console.error("Có lỗi xảy ra:", response?.message);
                setError(response?.message || "Có lỗi xảy ra!!!");
            }
        } catch (err: any) {
            console.error("Có lỗi xảy ra:", err);
            setError(err.message || "Có lỗi xảy ra!!!");
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        loading,
        error,
        caySam,
        getCaySam,
    };
}
